import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { AppComponent } from './app.component';
import { PolizaComponent } from './poliza/poliza.component';
import { PageNotFoundComponent } from './PageNotFound/pageNotFound.component';
import { ProductoComponent } from './poliza/producto/producto.component';
import { AmparosComponent } from './poliza/producto/amparo/amparos.component';
import { TextosComponent } from './poliza/textos/textos.component';
import { IntermediariosComponent } from './poliza/intermediarios/intermediarios.component';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { DocumentacionComponent } from './documentacion/documentacion.component';
import { ParametrizacionComponent } from './parametrizacion/parametrizacion.component';
import { ParametrizacionEnlacesComponent } from './parametrizacion-enlaces/parametrizacion-enlaces.component';
import { ReportesComponent } from './reportes/reportes.component';
import { CookieService } from 'ngx-cookie-service';
import { ChartsModule, ThemeService } from 'ng2-charts';
import { ReporteComponent } from './reportes/reporte/reporte.component';
import { ImpresionComponent } from './impresion/impresion.component';
import { HttpClientModule } from '@angular/common/http';
import { EnlacePrincipalComponent } from './enlace-principal/enlace-principal.component';
import { ConfiguracionesComponent } from './configuraciones/configuraciones.component';

@NgModule({
  declarations: [
    AppComponent,
    PolizaComponent,
    ProductoComponent,
    AmparosComponent,
    TextosComponent,
    ReporteComponent,
    ReportesComponent,
    IntermediariosComponent,
    DocumentacionComponent,
    PageNotFoundComponent,
    ParametrizacionComponent,
    ParametrizacionEnlacesComponent,
    ReportesComponent,
    ImpresionComponent,
    EnlacePrincipalComponent,
    ConfiguracionesComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    FormsModule,
    NgSelectModule,
    AppRoutingModule,
    ChartsModule,
    HttpClientModule
  ],
  providers: [ CookieService, ThemeService ],
  bootstrap: [ AppComponent ]
})
export class AppModule { }
